{
  "Year": "Year",
  "Minutes": "Minutes",
  "minutes": "minutes",
  "minute": "1 minute",
  "minute_plural": "{{count}} minutes",
  "Hours": "Hours",
  "hour": "1 hour",
  "hour_plural": "{{count}} hours",
  "Monday": "Monday",
  "Tuesday": "Tuesday",
  "Wednesday": "Wednesday",
  "Thursday": "Thursday",
  "Friday": "Friday",
  "Saturday": "Saturday",
  "Sunday": "Sunday",
  "day": "day",
  "week": "week",
  "month": "month",
  "year": "year"
}
